<script setup lang="ts">
import AppTooltip from '@/components/AppTooltip.vue'
import { Badge } from '@/components/ui/badge'
import { formatDateTime } from '@/lib/utils'

const props = defineProps<{
  status: string
  statusAt?: string | null
  rejectionReason?: string | null
}>()

const classMap: Record<string, string> = {
  new:      'border-transparent bg-gray-100 text-gray-700 hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-800',
  taken:    'border-transparent bg-orange-100 text-orange-800 hover:bg-orange-100 dark:bg-orange-900/40 dark:text-orange-300 dark:hover:bg-orange-900/40',
  accepted: 'border-transparent bg-sky-100 text-sky-800 hover:bg-sky-100 dark:bg-sky-900/40 dark:text-sky-300 dark:hover:bg-sky-900/40',
  approved: 'border-transparent bg-indigo-100 text-indigo-800 hover:bg-indigo-100 dark:bg-indigo-900/40 dark:text-indigo-300 dark:hover:bg-indigo-900/40',
  settled:  'border-transparent bg-green-100 text-green-800 hover:bg-green-100 dark:bg-green-900/40 dark:text-green-300 dark:hover:bg-green-900/40',
  rejected: 'border-transparent bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-900/40 dark:text-red-300 dark:hover:bg-red-900/40',
}

const label = props.status.charAt(0).toUpperCase() + props.status.slice(1)
</script>

<template>
  <AppTooltip v-if="statusAt" side="top" content-class="max-w-xs text-center">
    <Badge variant="outline" :class="classMap[status] ?? ''">
      {{ label }}
    </Badge>
    <template #content>
      <p>{{ label }} on {{ formatDateTime(statusAt) }}</p>
      <p v-if="rejectionReason" class="text-muted-foreground mt-0.5 text-xs">{{ rejectionReason }}</p>
    </template>
  </AppTooltip>

  <Badge v-else variant="outline" :class="classMap[status] ?? ''">
    {{ label }}
  </Badge>
</template>
